import React from 'react'
import { Modal, Button, Form, Spinner } from 'react-bootstrap'

const WifiConnectModal = ({
    show,
    ssid,
    password,
    showPassword,
    connecting,
    onPasswordChange,
    onToggleShowPassword,
    onHide,
    onConnect,
}) => {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Connect to "{ssid}"</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group>
                    <Form.Label>Password</Form.Label>
                    <div className='d-flex gap-2'>
                        <Form.Control
                            type={showPassword ? 'text' : 'password'}
                            value={password}
                            onChange={(e) => onPasswordChange(e.target.value)}
                            placeholder='Enter WiFi password'
                            onKeyDown={(e) => e.key === 'Enter' && onConnect()}
                        />
                        <Button
                            variant='outline-secondary'
                            onClick={onToggleShowPassword}
                            style={{ minWidth: 60 }}
                        >
                            {showPassword ? 'Hide' : 'Show'}
                        </Button>
                    </div>
                    <Form.Text className='text-muted'>Leave empty for open networks</Form.Text>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='light' onClick={onHide}>Cancel</Button>
                <Button variant='primary' onClick={onConnect} disabled={connecting}>
                    {connecting ? (
                        <><Spinner animation='border' size='sm' className='me-2' />Connecting...</>
                    ) : 'Connect'}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

const WifiDisconnectModal = ({ show, ssid, disconnecting, onHide, onDisconnect }) => {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Disconnect from WiFi</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Are you sure you want to disconnect from <strong>{ssid}</strong>?
                This will remove the saved connection profile.
            </Modal.Body>
            <Modal.Footer>
                <Button variant='light' onClick={onHide}>Cancel</Button>
                <Button variant='danger' onClick={onDisconnect} disabled={disconnecting}>
                    {disconnecting ? (
                        <><Spinner animation='border' size='sm' className='me-2' />Disconnecting...</>
                    ) : 'Disconnect'}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export { WifiConnectModal, WifiDisconnectModal }
